import { IMucThuKhacSinhVienGanThemRequest } from "../../model/request/chung-tu/IMucThuKhacSinhVienGanThemRequest";
import { IMucThuKhacSinhVienSaveRequest } from "../../model/request/chung-tu/IMucThuKhacSinhVienSaveRequest";
import { IMucThuKhacSinhVienSelectByLopsRequest } from "../../model/request/chung-tu/IMucThuKhacSinhVienSelectByLopsRequest";
import { IMucThuKhacSinhVienSelectRequest } from "../../model/request/chung-tu/IMucThuKhacSinhVienSelectRequest";
import { IMucThuKhacSinhVienTheoLopSelectRequest } from "../../model/request/chung-tu/IMucThuKhacSinhVienTheoLopSelectRequest";
import { IMucThuKhacSinhVienUpdateSoTienRequest } from "../../model/request/chung-tu/IMucThuKhacSinhVienUpdateSoTienRequest";
import { IIdsRequest } from "../../model/request/IIdsRequest";
import { IProcessRequest } from "../../model/request/IProcessRequest";
import { apiClient } from "../apiClient";
export const MUC_THU_KHAC_SINH_VIEN = "muc-thu-khac-sinh-vien";
export const mucThuKhacSinhVienApi = {
  SelectByLops: (request: IMucThuKhacSinhVienSelectByLopsRequest) =>
    apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}/select-by-lops`, request),
  SelectLichSu: (id: number) =>
    apiClient.get(`${MUC_THU_KHAC_SINH_VIEN}/lich-su/${id}`),
  SelectVmByLops: (request: IMucThuKhacSinhVienSelectByLopsRequest) =>
    apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}/selectvm-by-lops`, request),
  SelectByLopThuChi: (request: IMucThuKhacSinhVienTheoLopSelectRequest) =>
    apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}/select-by-lop-thuchi`, request),
  SelectBySinhVien: (request: IMucThuKhacSinhVienSelectRequest) =>
    apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}/select-by-sinhvien`, request),
  SelectKhoanThuSinhVien: (request: IMucThuKhacSinhVienSelectRequest) =>
    apiClient.post(
      `${MUC_THU_KHAC_SINH_VIEN}/select-khoan-thu-sinhvien`,
      request,
    ),
  // Gộp nhiều nguồn: 1 call cho tất cả biên lai nguồn (request.id_bien_lais), trả mảng khoản theo thứ tự nguồn.
  SelectKhoanThuSinhVienMulti: (request: IMucThuKhacSinhVienSelectRequest) =>
    apiClient.post(
      `${MUC_THU_KHAC_SINH_VIEN}/select-khoan-thu-sinhvien-multi`,
      request,
    ),
  Create: (request: IMucThuKhacSinhVienSaveRequest) =>
    apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}`, request),
  GanThem: (request: IMucThuKhacSinhVienGanThemRequest) =>
    apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}/gan-them`, request),
  Deletes: (request: IIdsRequest) =>
    apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}/deletes`, request),
  UpdateSoTien: (request: IMucThuKhacSinhVienUpdateSoTienRequest) =>
    apiClient.put(`${MUC_THU_KHAC_SINH_VIEN}/so-tien`, request),
  /** id_lop_tcs: chỉ chốt đúng các học phần này trong mức thu (mức thu tín chỉ gom cả đợt vào
   *  MỘT dòng, bỏ trống là duyệt cả đợt). */
  DuyetAsync: (
    request: IProcessRequest<number[]> & { id_lop_tcs?: number[] },
  ) =>
    apiClient.put(
      `${MUC_THU_KHAC_SINH_VIEN}/duyet?process_id=${request.process_id}` +
        (request.id_lop_tcs?.length
          ? `&id_lop_tcs=${request.id_lop_tcs.join(",")}`
          : ""),
      request.payload,
    ),
  HuyDuyetAsync: (request: IProcessRequest<number[]>) =>
    apiClient.put(
      `${MUC_THU_KHAC_SINH_VIEN}/huy-duyet?process_id=${request.process_id}`,
      request.payload,
    ),

  Import: (request: FormData) =>
    apiClient.upload(`${MUC_THU_KHAC_SINH_VIEN}/import`, request),
  SaveImport: (request: { cache_id: string; process_id: string }) =>
    apiClient.post(
      `${MUC_THU_KHAC_SINH_VIEN}/save-import/${request.cache_id}?process_id=${request.process_id}`,
    ),

  ImportHuyDuyet: (request: FormData) =>
    apiClient.upload(`${MUC_THU_KHAC_SINH_VIEN}/import-huy-duyet`, request),
  SaveImportHuyDuyet: (request: { cache_id: string; process_id: string }) =>
    apiClient.post(
      `${MUC_THU_KHAC_SINH_VIEN}/save-import-huy-duyet/${request.cache_id}?process_id=${request.process_id}`,
    ),

  // ===== Reset công nợ thôi học =====
  SelectSinhVienThoiHocCongNo: (request: { id_lops: number[] }) =>
    apiClient.post(
      `${MUC_THU_KHAC_SINH_VIEN}/select-sinh-vien-thoi-hoc-cong-no`,
      request,
    ),
  ResetCongNoThoiHoc: (request: { id_svs: string[] }, process_id: string) =>
    apiClient.put(
      `${MUC_THU_KHAC_SINH_VIEN}/reset-cong-no-thoi-hoc?process_id=${process_id}`,
      request,
    ),
  HoanTacXoaNo: (id_sv: string) =>
    apiClient.put(`${MUC_THU_KHAC_SINH_VIEN}/hoan-tac-xoa-no?id_sv=${id_sv}`),

  // ===== Hết thời gian nhập học (chốt phần còn thiếu của khoản học phí nhập học) =====
  HetHanNhapHocXemTruoc: (request: IHetHanNhapHocRequest) =>
    apiClient.post(
      `${MUC_THU_KHAC_SINH_VIEN}/het-han-nhap-hoc/xem-truoc`,
      request,
    ),
  HetHanNhapHocApDung: (request: IHetHanNhapHocRequest) =>
    apiClient.post(
      `${MUC_THU_KHAC_SINH_VIEN}/het-han-nhap-hoc/ap-dung`,
      request,
    ),
  HetHanNhapHocHoanTac: (request: IHetHanNhapHocRequest) =>
    apiClient.post(
      `${MUC_THU_KHAC_SINH_VIEN}/het-han-nhap-hoc/hoan-tac`,
      request,
    ),
};

export interface IHetHanNhapHocRequest {
  nam_nhap_hoc: string;
  /** 0 = mọi đợt của năm đó. */
  dot_nhap_hoc: number;
  /** true = chốt cả những em chưa đồng bộ tiền nhập học sang ví. */
  gom_ca_chua_dong_bo?: boolean;
  /** Hệ nhập học (hệ trên hồ sơ xét tuyển); rỗng = mọi hệ. */
  id_hes?: number[];
  /** Dòng mức thu được tích chọn; rỗng = toàn bộ theo bộ lọc. */
  ids?: number[];
}

/** Một khoản học phí nhập học còn thiếu, sẽ bị chốt. */
export interface IHetHanNhapHocRow {
  id: number;
  id_sv: string;
  ma_sv: string;
  ho_ten: string;
  ten_lop: string;
  ten_he: string;
  id_thu_chi: number;
  ten_thu_chi: string;
  hoc_ky: number;
  nam_hoc: string;
  so_tien_phai_nop: number;
  so_tien_da_nop: number;
  so_tien_con_lai: number;
  so_tien_da_dong_bo: number;
  so_tien_het_han_nhap_hoc: number;
  da_dong_bo: boolean;
}

export interface IHetHanNhapHocTongHop {
  so_sinh_vien: number;
  so_khoan: number;
  tong_con_lai: number;
  so_sv_da_dong_bo: number;
  so_sv_chua_dong_bo: number;
  tong_con_lai_chua_dong_bo: number;
}

export interface IHetHanNhapHocPreview {
  data: IHetHanNhapHocRow[];
  tong_hop: IHetHanNhapHocTongHop;
}

export interface IHetHanNhapHocKetQua {
  so_khoan: number;
  so_sinh_vien: number;
  tong_tien: number;
}
